// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";
import ElementUi from "element-ui";
import echarts from "echarts";
import "element-ui/lib/theme-chalk/index.css";
import locale from "element-ui/lib/locale/lang/zh-CN";
import common from "../common_function/common";
import $ from "jquery";
import "./assets/icon/iconfont.css";
import Http from "../common_function/http";
import store from "./store/index";
//  import VueWechatTitle from 'vue-wechat-title' //可以动态修改浏览器标题的插件
//  Vue.use(VueWechatTitle);
import vRggion from "v-region";
import VueResource from "vue-resource";
import VueDirectiveImagePreviewer from "vue-directive-image-previewer";
import "vue-directive-image-previewer/dist/assets/style.css";
import "vue-orgchart/dist/style.css";

import * as voicePromptFun from "./utils/voicePrompt";
import global from "../src/views/components/Global"; //引用文件

Vue.prototype.GLOBAL = global; //挂载到Vue实例上面复制代码

import "../common_function/filter";
// 注册全局过滤器
import Print from "vue-print-nb";
import Avue from "@smallwei/avue";
import "@smallwei/avue/lib/index.css";
Vue.use(Avue);
Vue.use(Print); //注册
import VueCropper from "vue-cropper";
Vue.use(VueCropper);
Vue.prototype.voicePrompt = voicePromptFun.voicePrompt; //语音提醒
Vue.use(VueDirectiveImagePreviewer);

Vue.use(VueResource);
// import './utils/rem'
//  import "./styles/common.css";
import XLSX from "xlsx";
// /common_function/commonData.js
import commonData from "../common_function/commonData";
import scroll from "vue-seamless-scroll";
import Video from "video.js";
import "video.js/dist/video-js.css";

Vue.prototype.$video = Video;
Vue.use(scroll);
Vue.use(vRggion);
Vue.prototype.commonData = commonData;

Vue.prototype.XLSX = XLSX;
// import 'echarts-gl'
Vue.config.productionTip = false;

Vue.use(ElementUi, { locale });
Vue.prototype.common = common;
Vue.prototype.$echarts = echarts;
Vue.prototype.$Http = Http;
window.$ = window.jQuery = $;
import dataV from "@jiaminghi/data-view";

Vue.use(dataV);

/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  store,
  components: { App },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js